import { z } from "zod";

/**
 * Maps an inbound hostname to the store (organization) it resolves to.
 * Public, unauthenticated traffic is routed by `Host` header alone — see
 * `apps/backend/src/plugins/org.ts` — so this is the record that decides
 * which tenant a request belongs to before any session exists.
 */
export const DomainSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  hostname: z.string().min(1).max(253),
  isPrimary: z.boolean().default(false),
  verifiedAt: z.string().datetime().nullable().default(null),
});
export type Domain = z.infer<typeof DomainSchema>;
